"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_TestReport_Assert = exports.TestReport_AssertResultKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_markdown_1 = require("../Scalar/RTTI_markdown");
var TestReport_AssertResultKind;
(function (TestReport_AssertResultKind) {
    TestReport_AssertResultKind["_pass"] = "pass";
    TestReport_AssertResultKind["_skip"] = "skip";
    TestReport_AssertResultKind["_fail"] = "fail";
    TestReport_AssertResultKind["_warning"] = "warning";
    TestReport_AssertResultKind["_error"] = "error";
})(TestReport_AssertResultKind = exports.TestReport_AssertResultKind || (exports.TestReport_AssertResultKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_TestReport_Assert = t.recursion('ITestReport_Assert', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        result: (0, EnumType_1.createEnumType)(TestReport_AssertResultKind, 'TestReport_AssertResultKind'),
        _result: RTTI_Element_1.RTTI_Element,
        message: RTTI_markdown_1.RTTI_markdown,
        _message: RTTI_Element_1.RTTI_Element,
        detail: t.string,
        _detail: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_TestReport_Assert.js.map